// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_loginContainer__JNl76 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: var(--color-bg);
  padding: 20px;
}

.Login_loginCard__LKOId {
  background: var(--color-bg-panel);
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 100%;
}

.Login_loginCard__LKOId h2 {
  color: var(--color-text);
  margin-bottom: 10px;
  font-size: 28px;
  font-weight: 600;
}

.Login_loginCard__LKOId p {
  color: var(--color-text-muted);
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 1.5;
}

.Login_googleButton__6-UNu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 24px;
  background: var(--color-bg-alt);
  border: 2px solid var(--color-border);
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  color: var(--color-text);
  cursor: pointer;
  transition: all 0.3s ease;
  gap: 12px;
}

.Login_googleButton__6-UNu:hover {
  background: var(--color-bg-muted);
  border-color: var(--color-accent);
  box-shadow: 0 2px 8px rgba(66, 133, 244, 0.2);
}

.Login_googleButton__6-UNu:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.Login_googleIcon__mabug {
  width: 20px;
  height: 20px;
}

@media (max-width: 480px) {
  .Login_loginCard__LKOId {
    padding: 30px 20px;
  }
  
  .Login_loginCard__LKOId h2 {
    font-size: 24px;
  }
  
  .Login_googleButton__6-UNu {
    padding: 10px 20px;
    font-size: 14px;
  }
}

.Login_debugInfo__i6wu0 {
  margin-top: 2rem;
  padding: 1rem;
  background: var(--color-bg-muted);
  border-radius: 8px;
  border: 1px solid var(--color-border);
}

.Login_debugInfo__i6wu0 h4 {
  color: var(--color-text);
  margin: 0 0 1rem 0;
  font-size: 14px;
  font-weight: 600;
}

.Login_debugInfo__i6wu0 p {
  color: var(--color-text-muted);
  margin: 0.5rem 0;
  font-size: 12px;
  font-family: monospace;
} `, "",{"version":3,"sources":["webpack://./src/components/Auth/Login.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB","sourcesContent":[".loginContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: var(--color-bg);\n  padding: 20px;\n}\n\n.loginCard {\n  background: var(--color-bg-panel);\n  border-radius: 12px;\n  padding: 40px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  max-width: 400px;\n  width: 100%;\n}\n\n.loginCard h2 {\n  color: var(--color-text);\n  margin-bottom: 10px;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.loginCard p {\n  color: var(--color-text-muted);\n  margin-bottom: 30px;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.googleButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 12px 24px;\n  background: var(--color-bg-alt);\n  border: 2px solid var(--color-border);\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--color-text);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  gap: 12px;\n}\n\n.googleButton:hover {\n  background: var(--color-bg-muted);\n  border-color: var(--color-accent);\n  box-shadow: 0 2px 8px rgba(66, 133, 244, 0.2);\n}\n\n.googleButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.googleIcon {\n  width: 20px;\n  height: 20px;\n}\n\n@media (max-width: 480px) {\n  .loginCard {\n    padding: 30px 20px;\n  }\n  \n  .loginCard h2 {\n    font-size: 24px;\n  }\n  \n  .googleButton {\n    padding: 10px 20px;\n    font-size: 14px;\n  }\n}\n\n.debugInfo {\n  margin-top: 2rem;\n  padding: 1rem;\n  background: var(--color-bg-muted);\n  border-radius: 8px;\n  border: 1px solid var(--color-border);\n}\n\n.debugInfo h4 {\n  color: var(--color-text);\n  margin: 0 0 1rem 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.debugInfo p {\n  color: var(--color-text-muted);\n  margin: 0.5rem 0;\n  font-size: 12px;\n  font-family: monospace;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginContainer": `Login_loginContainer__JNl76`,
	"loginCard": `Login_loginCard__LKOId`,
	"googleButton": `Login_googleButton__6-UNu`,
	"googleIcon": `Login_googleIcon__mabug`,
	"debugInfo": `Login_debugInfo__i6wu0`
};
export default ___CSS_LOADER_EXPORT___;
